export const cardData3 = [
  {
    title: "HTML",
    subtitle: "Designing using html",
    filepath: "/Fullstack/html.md",
    content:
      "Understand how a TCP connection is established between client and server using the SYN, SYN-ACK, and ACK steps.",
  },
];
